import React, { FC } from 'react'
import { useHistoryNew } from '@utils'
import mktController from 'controllers/mktController'
import './index.scss'

interface IProps {
  info: any;
}

const ActiveModule: FC<IProps> = (props: IProps) => {
  const { info } = props
  const history = useHistoryNew()
  const handleGo = (e: any, path: string, needLogin: boolean, needMember: boolean) => {
    e && e.stopPropagation()
    mktController.checkLogin(history, needLogin, needMember).then(() => {
      mktController.adToActive(history, path)
    })
  }
  const isLogin = () => {
    if (info.jumpUrl.indexOf('bindMobile') > -1) {
      return false
    } else {
      return true
    }
  }
  return (
    <div
      data-cypid='mmgToActivity'
      className='active-module'
      onClick={(e: any) => handleGo(e, info.jumpUrl, isLogin(), false)}
    >
      <img src={info.img || ''} alt='' />
    </div>
  )
}

export default ActiveModule
